import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  taskItemLoader: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
  },
});

const ContentLoading = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Skeleton
        className={classes.taskItemLoader}
        variant="rect"
        width={'100%'}
        height={74}
      />
      <Skeleton
        className={classes.taskItemLoader}
        variant="rect"
        width={'100%'}
        height={74}
      />
      <Skeleton
        className={classes.taskItemLoader}
        variant="rect"
        width={'100%'}
        height={74}
      />
    </Box>
  );
};

ContentLoading.defaultProps = {
  className: '',
};

ContentLoading.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContentLoading);
